import { render } from "./BuyHeader.vue?vue&type=template&id=45c8fa46"
import script from "./BuyHeader.vue?vue&type=script&lang=js"
export * from "./BuyHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__